import { createApp } from 'vue';

import App from './App.vue';
import store from './store/Index.js';
import router from './router/router.js';
import func from './assets/functions.js';
import './plugins/axios';

import NavBar from './components/NavBar.vue';
import Modale from './components/Modale.vue';
import AlertDisplay from './components/AlertDisplay.vue';
import MultiSelect from './components/MultiSelect.vue';
import TextEditor from './components/TextEditor.vue';
import LoaderSpin from './components/LoaderSpin.vue';
import CurrencyInput from './components/CurrencyInput.vue';
import PercentInput from './components/PercentInput.vue';
import FileDrop from './components/FileDrop.vue';
import SearchableSelect from './components/SearchableSelect.vue';
import ToolTip from './components/ToolTip.vue';

import '@/assets/main.style.css'; 

async function init() {
    // ⚠️ Initialise le store AVANT d'utiliser le router
    try {
        await store.dispatch('refreshAccessToken');
    } catch (err) {
        console.log('Pas de refresh')
    }

    const app = createApp(App);

    app.use(store);
    app.use(router);

    app.mixin({
        methods: {
            capitalize: func.capitalize,
            toEuro: func.toEuro,
            toPercent: func.toPercent,
            dateToString: func.dateToString,
        }
    });

    app.component('NavBar', NavBar);
    app.component('modale', Modale);
    app.component('searchable-select', SearchableSelect);
    app.component('alert-display', AlertDisplay);
    app.component('multi-select', MultiSelect);
    app.component('text-editor', TextEditor);
    app.component('loader-spin', LoaderSpin);
    app.component('currency-input', CurrencyInput);
    app.component('percent-input', PercentInput);
    app.component('file-drop', FileDrop);
    app.component('tooltip', ToolTip);

    app.mount('#app');
}

init();
